import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { DashboardComponent } from './dashboard.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { ngxPermissionsGuard } from 'ngx-permissions'

export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard, ngxPermissionsGuard],
        data: {
          permissions: {
            only: 'DASHBOARD',
            redirectTo: '/',
          },
        },
        component: DashboardComponent,
      },
    ],
  },
]
